import LinkURLData from './LinkURLData';
import { URLOpenType } from './URLOpenType';
import { URLTargetType } from './URLTargetType';

class LinkData {
  title: string;
  linkData?: LinkURLData;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace LinkData {
  export function make(title: string, url?: string, targetType?: URLTargetType, openType?: URLOpenType): LinkData {
    return {
      title,
      linkData: {
        url,
        targetType,
        openType,
      },
    };
  }

  export function getDefault(title = 'Details'): LinkData {
    return make(title, '', URLTargetType.INTERNAL, URLOpenType.SAME_PAGE);
  }
}

export default LinkData;
